

<div class="user-assign-schedules-wrapper">
  <!-- Toast -->
  <div class="toast show" *ngIf="toastMessage" [class.success]="toastKind === 'success'"
    [class.error]="toastKind === 'error'" [class.warning]="toastKind === 'info'" (click)="clearToast()" role="status"
    aria-live="polite">
    <img class="icon"
      [src]="toastKind === 'success' ? '/success.png' : toastKind === 'error' ? '/fail.png' : '/warning.png'" alt=""
      aria-hidden="true" />

    <div>
      <div class="toast-title">
        {{ toastKind === 'success' ? 'Success' : toastKind === 'error' ? 'Action needed' : 'Notice' }}
      </div>
      <div class="toast-body">{{ toastMessage }}</div>
    </div>
  </div>



  <header class="schedule-page-header">
    <div>
      <p class="eyebrow">Scheduling Management</p>
      <h1>Assign Schedules</h1>
    </div>
  </header>

  <nav class="schedule-tabs" aria-label="Schedule sections">
    <a
      class="schedule-tab"
      routerLink="/scheduling/schedule-groups"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <path d="M16 2v4" />
        <path d="M8 2v4" />
        <path d="M3 10h18" />
      </svg>
      Default Schedules
    </a>

    <a
      class="schedule-tab"
      routerLink="/scheduling/user-assign-schedules"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M8 7h12" />
        <path d="M8 12h12" />
        <path d="M8 17h12" />
        <path d="M4 7h.01" />
        <path d="M4 12h.01" />
        <path d="M4 17h.01" />
      </svg>
      Assign Schedules
    </a>

    <a
      class="schedule-tab"
      routerLink="/scheduling/scheduling-sync"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M21 12a9 9 0 0 1-9 9 8.5 8.5 0 0 1-6-2.5" />
        <path d="M3 12a9 9 0 0 1 15-6.7" />
        <path d="M18 3v5h-5" />
        <path d="M6 21v-5h5" />
      </svg>
      Sync Schedules
    </a>
  </nav>

  <!-- Header -->
  <div class="header">
    <div *ngIf="isLoadingWeek || isLoadingWeeks" class="spinner-container">
      <div class="spinner"></div>
    </div>

    <button *ngIf="!(isLoadingWeek || isLoadingWeeks)" type="button" class="nav-btn" (click)="prevWeek()">
      ← Prev Week
    </button>

    <div class="week-label" *ngIf="!(isLoadingWeek || isLoadingWeeks)">
      <div class="week-title">Week</div>
      <div class="week-dates">{{ weekLabel }}</div>
    </div>

    <button *ngIf="!(isLoadingWeek || isLoadingWeeks)" type="button" class="nav-btn" (click)="nextWeek()">
      Next Week →
    </button>

    <div class="year-picker" *ngIf="!isLoadingWeeks">
      <label class="year-label">Year</label>
      <select class="year-select" [ngModel]="selectedYear" (ngModelChange)="onYearChange($event)">
        <option *ngFor="let y of years; trackBy: trackByYear" [ngValue]="y">{{ y }}</option>
      </select>
    </div>

    <div class="selection-summary" *ngIf="!(isLoadingWeek || isLoadingWeeks) && selectedEmployeeIds.size > 0">
      <div class="selection-pill">
        {{ selectedEmployeeIds.size }} selected
      </div>

      <button type="button" class="nav-btn subtle" (click)="clearSelectedEmployees()">
        Clear Selection
      </button>

      <button type="button" class="nav-btn" (click)="openManualBulkCreateForSelectedWeek()">
        Create for Selected
      </button>
    </div>

    <div class="inline-actions" *ngIf="!(isLoadingWeek || isLoadingWeeks) && hasInlineChanges">
      <button type="button" class="nav-btn" [disabled]="isSaving" (click)="cancelInlineEdits()">
        Cancel Changes
      </button>

      <button type="button" class="nav-btn primary" [disabled]="isSaving" (click)="saveInlineEdits()">
        <span *ngIf="!isSaving">Save Changes</span>
        <span *ngIf="isSaving" class="saving-inline">
          <span class="btn-spinner" aria-hidden="true"></span>
          Saving…
        </span>
      </button>
    </div>
  </div>

  <!-- Color Key -->
  <div class="color-key" *ngIf="!(isLoadingWeek || isLoadingWeeks)">
    <div class="key-item">
      <div class="key-block scheduled"></div>
      Assigned Schedule
    </div>

    <div class="key-item">
      <div class="key-block template"></div>
      Template (drag)
    </div>

    <div class="key-item">
      <div class="key-block overnight"></div>
      Overnight
    </div>

    <div class="key-item">
      <div class="key-block editing"></div>
      Inline Edit
    </div>

    <div class="key-item">
      <div class="key-block selected"></div>
      Selected Employee
    </div>
  </div>

  <div class="layout" [class.sidebar-closed]="!sidebarOpen">
    <!-- Main -->
    <div class="main">
      <div class="timeline-container">
        <div class="timeline-scroll" #timelineScroll>
          <div class="timeline-grid" #timelineGrid>
            <!-- Header row -->
            <div class="grid-header">
              <div class="employee-header">
                <div class="employee-header-inner">
                  <div class="employee-col-title">Employees</div>
                  <div class="employee-col-subtitle">Select one or more, then drag templates</div>
                </div>
              </div>

              <div class="day-headers">
                <div class="day-header" *ngFor="let d of weekDays">
                  <div class="day-name">{{ d.label }}</div>
                  <div class="day-date">{{ d.date | date: 'MMM d' }}</div>
                </div>
              </div>
            </div>

            <!-- Body -->
            <div class="grid-body">
              <div *ngFor="let emp of weekSchedules$ | async; trackBy: trackByEmployeeId" class="grid-row">
                <!-- Employee cell -->
                <div class="employee-cell" [class.drop-active]="isTemplateDragging"
                  [class.drop-hover]="hoverEmployeeId === emp.id" [class.selected]="isEmployeeSelected(emp.id)"
                  (dragenter)="onLaneDragEnter($event, emp.id)" (dragleave)="onLaneDragLeave($event, emp.id)"
                  (dragover)="onLaneDragOver($event)" (drop)="onDropToEmployee($event, emp.id)"
                  (contextmenu)="onOpenContextMenu($event, emp.id, weekDays[0].ymd || '')"
                  title="Drop template here to apply the full template schedule to this employee">
                  <div class="emp-main" *ngIf="!isTemplateDragging">
                    <label class="emp-select" [attr.aria-label]="'Select ' + emp.lastName + ', ' + emp.firstName">
                      <input type="checkbox" [checked]="isEmployeeSelected(emp.id)" (click)="$event.stopPropagation()"
                        (change)="toggleEmployeeSelected(emp.id)" />
                      <span class="emp-checkmark"></span>
                    </label>

                    <div class="emp-name-wrap">
                      <div class="emp-name">
                        {{ emp.lastName }}, {{ emp.firstName }}
                      </div>
                      <div class="emp-id">ID {{ emp.id }}</div>
                    </div>

                    <button type="button" class="emp-add" (click)="openQuickAddForEmployee(emp.id)"
                      aria-label="Quick add schedule for multiple days" title="Quick add (multiple days)">
                      +
                    </button>
                  </div>

                  <div class="drop-label employee" *ngIf="isTemplateDragging">
                    <div class="drop-emp">
                      {{ emp.lastName }}, {{ emp.firstName }}
                      <span class="emp-id">({{ emp.id }})</span>
                    </div>
                    <div class="drop-text">
                      Drop here to apply <strong>full template schedule</strong>.
                    </div>
                  </div>
                </div>

                <!-- Week lane -->
                <div class="week-lane" [class.drop-active]="isTemplateDragging"
                  [class.drop-hover]="hoverEmployeeId === emp.id" [class.employee-selected]="isEmployeeSelected(emp.id)"
                  (dragenter)="onLaneDragEnter($event, emp.id)" (dragleave)="onLaneDragLeave($event, emp.id)"
                  (dragover)="onLaneDragOver($event)" (drop)="onDropToWeekLane($event, emp.id)"
                  (contextmenu)="onOpenContextMenu($event, emp.id, weekDays[0].ymd || '')"
                  title="Drop template on a specific day (under cursor)">
                  <div class="day-dropzones" *ngIf="isTemplateDragging">
                    <div class="day-dropzone" *ngFor="let d of weekDays; let i = index"
                      [class.hover]="hoverEmployeeId === emp.id && hoverDayIndex === i"
                      (dragover)="$event.preventDefault(); $event.stopPropagation(); onLaneDragOver($event)"
                      (drop)="$event.preventDefault(); $event.stopPropagation(); onDropToDayCell(emp.id, d.ymd)"
                      [attr.data-day]="d.key" [title]="'Drop to apply template on ' + d.label">
                      <div class="drop-label day">{{ d.label }} drop</div>
                    </div>
                  </div>

                  <div class="week-stripes" aria-hidden="true">
                    <div *ngFor="let _ of [].constructor(168); let i = index" [class.even]="i % 2 === 0"></div>
                  </div>

                  <div class="week-hour-labels" aria-hidden="true">
                    <div *ngFor="let _ of [].constructor(168); let i = index">
                      {{ (i % 24 < 10 ? '0' + (i % 24) : i % 24) + ':00' }} </div>
                    </div>

                    <div class="day-separators" aria-hidden="true">
                      <div *ngFor="let _ of weekDays; let i = index" class="sep"></div>
                    </div>

                    <!-- Existing assigned blocks -->
                    <ng-container *ngFor="let b of emp.schedules">
                      <div class="schedule-block week-block" [class.overnight]="getEffectiveBlock(b).isOvernight"
                        [class.editing]="inlineEditAssignmentId === b.assignmentId"
                        [style.left.%]="getLeftPercentForWeek(b)" [style.width.%]="getWidthPercentForWeek(b)"
                        (contextmenu)="onOpenContextMenu($event, emp.id, weekDays[0].ymd || '', b.assignmentId)">
                        <div class="resize-handle left" *ngIf="inlineEditAssignmentId === b.assignmentId"
                          (pointerdown)="onInlineHandlePointerDown($event, b, 'resizeStart')"
                          title="Drag to adjust start"></div>

                        <div class="resize-handle right" *ngIf="inlineEditAssignmentId === b.assignmentId"
                          (pointerdown)="onInlineHandlePointerDown($event, b, 'resizeEnd')" title="Drag to adjust end">
                        </div>

                        <div class="block-body" [class.draggable]="inlineEditAssignmentId === b.assignmentId"
                          (pointerdown)="onInlineBlockPointerDown($event, b)" [title]="getBlockLabelForWeek(b)">
                          <span class="time-label">{{ getBlockLabelForWeek(b) }}</span>
                        </div>
                      </div>
                    </ng-container>

                    <!-- Day add buttons -->
                    <ng-container *ngFor="let d of weekDays; let i = index">
                      <button type="button" class="quick-add day" [style.left.%]="(((i * 24) + 0.5) / 168) * 100"
                        (click)="openEditDraftWithDefaults({
                        employeeId: emp.id,
                        ymd: d.ymd,
                        startTime: '06:00',
                        endTime: '16:00',
                        isOvernight: false
                      })" aria-label="Add schedule" [title]="'Add schedule on ' + d.label">
                        +
                      </button>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Context Menu -->
          <div class="context-menu" *ngIf="contextMenu.open" [style.left.px]="contextMenu.x"
            [style.top.px]="contextMenu.y">
            <button type="button" class="ctx-item" *ngIf="contextMenu.assignmentId != null"
              (click)="enableInlineEdit(contextMenu.assignmentId!, contextMenu.employeeId); closeContextMenu()">
              Edit (drag)
            </button>

            <button type="button" class="ctx-item" (click)="openEditDraftFromContext()">
              Edit Advanced…
            </button>

            <button type="button" class="ctx-item" *ngIf="canDeleteContextSchedule" (click)="openDeleteFromContext()">
              Delete
            </button>

            <button type="button" class="ctx-item" (click)="closeContextMenu()">Close</button>
          </div>

          <!-- Delete Confirm Modal -->
          <div class="edit-overlay" *ngIf="deleteConfirmOpen">
            <div class="edit-panel">
              <div class="edit-header">
                <div class="edit-title">Delete Schedule</div>
                <button type="button" class="edit-close" [disabled]="isDeleting" (click)="cancelDeleteSchedule()">
                  ×
                </button>
              </div>

              <div class="edit-body">
                <div class="edit-row">
                  <div class="edit-value">
                    Are you sure you want to delete this schedule?
                  </div>
                </div>

                <div class="edit-row" *ngIf="deleteTarget?.label">
                  <div class="edit-value">{{ deleteTarget?.label }}</div>
                </div>
              </div>

              <div class="edit-actions">
                <button type="button" class="btn ghost" [disabled]="isDeleting" (click)="cancelDeleteSchedule()">
                  Cancel
                </button>

                <button type="button" class="btn primary" [disabled]="isDeleting" (click)="confirmDeleteSchedule()">
                  <span *ngIf="!isDeleting">Delete</span>
                  <span *ngIf="isDeleting" class="saving-inline">
                    <span class="btn-spinner" aria-hidden="true"></span>
                    Deleting…
                  </span>
                </button>
              </div>
            </div>
          </div>

          <!-- Quick Add Modal -->
          <div class="edit-overlay" *ngIf="quickAddDraft">
            <div class="edit-panel">
              <div class="edit-header">
                <div class="edit-title">Quick Add Schedule (multiple days)</div>
                <button type="button" class="edit-close" [disabled]="isQuickAddSaving" (click)="cancelQuickAdd()">
                  ×
                </button>
              </div>

              <div class="edit-body">
                <div class="edit-row">
                  <div class="edit-label">Employee</div>
                  <div class="edit-value">{{ getEmployeeDisplayName(quickAddDraft.employeeId) }}</div>
                </div>

                <div class="edit-row two">
                  <div>
                    <div class="edit-label">Start</div>
                    <input type="time" [(ngModel)]="quickAddDraft.startTime" [disabled]="isQuickAddSaving" />
                  </div>

                  <div>
                    <div class="edit-label">End</div>
                    <input type="time" [(ngModel)]="quickAddDraft.endTime" [disabled]="isQuickAddSaving" />
                  </div>
                </div>

                <div class="edit-row">
                  <div class="edit-label">Department</div>
                  <select [(ngModel)]="quickAddDraft.departmentId" [disabled]="isQuickAddSaving">
                    <option [ngValue]="null">Select department…</option>
                    <option *ngFor="let d of filterService.filterValues?.departments" [ngValue]="d.id">
                      {{ d.name }}<span *ngIf="d.code != null"> ({{ d.code }})</span>
                    </option>
                  </select>
                </div>

                <div class="edit-row">
                  <div class="edit-label">Shift</div>
                  <select [(ngModel)]="quickAddDraft.shiftId" [disabled]="isQuickAddSaving">
                    <option [ngValue]="null">Select shift…</option>
                    <option *ngFor="let s of filterService.filterValues?.shifts" [ngValue]="s.id">{{ s.name }}</option>
                  </select>
                </div>

                <div class="edit-row">
                  <div class="edit-label">Apply to days</div>

                  <div class="day-checks" role="group" aria-label="Select days to apply schedule">
                    <label class="day-check" *ngFor="let d of weekDays; let i = index">
                      <input type="checkbox" [checked]="quickAddDraft.selectedDayIdx[i]" [disabled]="isQuickAddSaving"
                        (change)="toggleQuickAddDay(i)" />
                      <span class="day-pill">
                        {{ d.label }}
                        <span class="day-date">{{ d.date | date: 'MMM d' }}</span>
                      </span>
                    </label>
                  </div>

                  <div class="day-check-hint">
                    Selected: {{ quickAddSelectedCount }}
                  </div>
                </div>
              </div>

              <div class="edit-actions">
                <button type="button" class="btn ghost" [disabled]="isQuickAddSaving" (click)="cancelQuickAdd()">
                  Cancel
                </button>

                <button type="button" class="btn primary" [disabled]="
                  isQuickAddSaving ||
                  !quickAddDraft.departmentId ||
                  !quickAddDraft.shiftId ||
                  quickAddSelectedCount === 0
                " (click)="saveQuickAdd()">
                  <span *ngIf="!isQuickAddSaving">Save</span>
                  <span *ngIf="isQuickAddSaving" class="saving-inline">
                    <span class="btn-spinner" aria-hidden="true"></span>
                    Saving…
                  </span>
                </button>
              </div>
            </div>
          </div>

          <!-- Shared Edit Modal -->
          <div class="edit-overlay" *ngIf="editDraft">
            <div class="edit-panel">
              <div class="edit-header">
                <div class="edit-title">
                  {{ editModalTitle || 'Edit Schedule' }}
                </div>
                <button type="button" class="edit-close" [disabled]="isSaving" (click)="cancelEdit()">
                  ×
                </button>
              </div>

              <div class="edit-body">
                <div class="edit-row" *ngIf="editQueueProgressText">
                  <div class="edit-label">Progress</div>
                  <div class="edit-value">{{ editQueueProgressText }}</div>
                </div>

                <div class="edit-row" *ngIf="editQueueContextText">
                  <div class="edit-label">Scope</div>
                  <div class="edit-value">{{ editQueueContextText }}</div>
                </div>

                <div class="edit-row" *ngIf="showSingleEmployeeInEditModal">
                  <div class="edit-label">Employee</div>
                  <div class="edit-value">{{ getEmployeeDisplayName(editDraft.employeeId) }}</div>
                </div>

                <div class="edit-row" *ngIf="showMultiEmployeeSummaryInEditModal">
                  <div class="edit-label">Employees</div>
                  <div class="edit-value">
                    {{ editModalSelectedEmployeeCount }} selected employee{{ editModalSelectedEmployeeCount === 1 ? '' :
                    's' }}
                  </div>
                </div>

                <div class="edit-row">
                  <div class="edit-label">Date</div>
                  <div class="edit-value">{{ editDraft.ymd }}</div>
                </div>

                <div class="edit-row two">
                  <div>
                    <div class="edit-label">Start</div>
                    <input type="time" [(ngModel)]="editDraft.startTime" [disabled]="isSaving" />
                  </div>

                  <div>
                    <div class="edit-label">End</div>
                    <input type="time" [(ngModel)]="editDraft.endTime" [disabled]="isSaving" />
                  </div>
                </div>

                <div class="edit-row">
                  <div class="edit-label">Department</div>
                  <select [(ngModel)]="editDraft.departmentId" [disabled]="isSaving">
                    <option [ngValue]="null">Select department…</option>
                    <option *ngFor="let d of filterService.filterValues?.departments" [ngValue]="d.id">
                      {{ d.name }}<span *ngIf="d.code != null"> ({{ d.code }})</span>
                    </option>
                  </select>
                </div>

                <div class="edit-row">
                  <div class="edit-label">Shift</div>
                  <select [(ngModel)]="editDraft.shiftId" [disabled]="isSaving">
                    <option [ngValue]="null">Select shift…</option>
                    <option *ngFor="let s of filterService.filterValues?.shifts" [ngValue]="s.id">{{ s.name }}</option>
                  </select>
                </div>
              </div>

              <div class="edit-actions">
                <button type="button" class="btn ghost" [disabled]="isSaving" (click)="cancelEdit()">
                  <span *ngIf="!isSaving">Cancel</span>
                  <span *ngIf="isSaving" class="saving-inline">Cancel</span>
                </button>

                <button *ngIf="showEditApplyAllButton" type="button" class="btn ghost"
                  [disabled]="isSaving || !editDraft.departmentId || !editDraft.shiftId" (click)="onModalApplyAll()"
                  [title]="editApplyAllButtonTitle || 'Apply the same Department + Shift to all remaining days'">
                  <span *ngIf="!isSaving">Apply to all</span>
                  <span *ngIf="isSaving" class="saving-inline">
                    <span class="btn-spinner" aria-hidden="true"></span>
                    Applying…
                  </span>
                </button>

                <button type="button" class="btn primary"
                  [disabled]="isSaving || !editDraft.departmentId || !editDraft.shiftId" (click)="onModalNext()">
                  <span *ngIf="!isSaving">{{ modalPrimaryLabel || 'Save' }}</span>
                  <span *ngIf="isSaving" class="saving-inline">
                    <span class="btn-spinner" aria-hidden="true"></span>
                    Saving…
                  </span>
                </button>
              </div>
            </div>
          </div>

          <!-- Bulk Assign Modal -->
          <div class="edit-overlay" *ngIf="bulkAssignDraft">
            <div class="edit-panel">
              <div class="edit-header">
                <div class="edit-title">{{ bulkAssignDraft.title }}</div>
                <button type="button" class="edit-close" [disabled]="isBulkSaving" (click)="cancelBulkAssign()">
                  ×
                </button>
              </div>

              <div class="edit-body">
                <div class="edit-row">
                  <div class="edit-label">Employees</div>
                  <div class="edit-value">
                    {{ bulkAssignSelectedEmployeeCount }} selected employee{{ bulkAssignSelectedEmployeeCount === 1 ? ''
                    : 's' }}
                  </div>
                </div>

                <div class="edit-row two">
                  <div>
                    <div class="edit-label">Start</div>
                    <input type="time" [(ngModel)]="bulkAssignDraft.startTime" [disabled]="isBulkSaving" />
                  </div>

                  <div>
                    <div class="edit-label">End</div>
                    <input type="time" [(ngModel)]="bulkAssignDraft.endTime" [disabled]="isBulkSaving" />
                  </div>
                </div>

                <div class="edit-row">
                  <div class="edit-label">Department</div>
                  <select [(ngModel)]="bulkAssignDraft.departmentId" [disabled]="isBulkSaving">
                    <option [ngValue]="null">Select department…</option>
                    <option *ngFor="let d of filterService.filterValues?.departments" [ngValue]="d.id">
                      {{ d.name }}<span *ngIf="d.code != null"> ({{ d.code }})</span>
                    </option>
                  </select>
                </div>

                <div class="edit-row">
                  <div class="edit-label">Shift</div>
                  <select [(ngModel)]="bulkAssignDraft.shiftId" [disabled]="isBulkSaving">
                    <option [ngValue]="null">Select shift…</option>
                    <option *ngFor="let s of filterService.filterValues?.shifts" [ngValue]="s.id">{{ s.name }}</option>
                  </select>
                </div>

                <div class="edit-row">
                  <div class="edit-label">Apply to days</div>

                  <div class="day-checks" role="group" aria-label="Select days to apply schedule">
                    <label class="day-check" *ngFor="let d of weekDays; let i = index">
                      <input type="checkbox" [checked]="bulkAssignDraft.selectedDayIdx[i]" [disabled]="isBulkSaving"
                        (change)="toggleBulkAssignDay(i)" />
                      <span class="day-pill">
                        {{ d.label }}
                        <span class="day-date">{{ d.date | date: 'MMM d' }}</span>
                      </span>
                    </label>
                  </div>

                  <div class="day-check-hint">
                    Selected: {{ bulkAssignSelectedDayCount }}
                  </div>
                </div>
              </div>

              <div class="edit-actions">
                <button type="button" class="btn ghost" [disabled]="isBulkSaving" (click)="cancelBulkAssign()">
                  Cancel
                </button>

                <button type="button" class="btn primary" [disabled]="
                  isBulkSaving ||
                  !bulkAssignDraft.departmentId ||
                  !bulkAssignDraft.shiftId ||
                  bulkAssignSelectedDayCount === 0
                " (click)="saveBulkAssign()">
                  <span *ngIf="!isBulkSaving">Save</span>
                  <span *ngIf="isBulkSaving" class="saving-inline">
                    <span class="btn-spinner" aria-hidden="true"></span>
                    Saving…
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sidebar -->
      <aside class="sidebar" [class.closed]="!sidebarOpen" *ngIf="!(isLoadingWeek || isLoadingWeeks)">
        <div class="sidebar-handle" *ngIf="!sidebarOpen">
          <button type="button" class="handle-btn" (click)="toggleSidebar()">»</button>
        </div>

        <div class="sidebar-panel" *ngIf="sidebarOpen">
          <div class="sidebar-header">
            <div class="sidebar-title">Schedule Templates</div>
            <button class="sidebar-toggle" type="button" (click)="toggleSidebar()">«</button>
          </div>

          <div class="sidebar-body">
            <div class="template-hint">
              Drag a template onto a day lane, employee row, or selected employees target.
            </div>

            <div class="selected-dropzone" *ngIf="selectedEmployeeIds.size > 0">
              <div class="selected-dropzone-title">Selected Employees</div>

              <div class="selected-dropzone-count">
                {{ selectedEmployeeIds.size }} selected
              </div>

              <div class="selected-dropzone-text">
                Drop on the full week target to assign the whole template, or drop on a specific day below.
              </div>

              <!-- Full week drop target -->
              <div class="selected-full-week-target" [class.drag-active]="isTemplateDragging"
                [class.hover]="isSelectedDropzoneHover && hoverSelectedEmployeesDayIndex == null"
                [class.invalid]="isTemplateDragging && selectedTemplateHasNoWeekDays"
                (dragenter)="onSelectedEmployeesDragEnter($event)" (dragover)="onSelectedEmployeesDragOver($event)"
                (dragleave)="onSelectedEmployeesDragLeave($event)" (drop)="onDropToSelectedEmployees($event)"
                title="Drop template here to assign the full template week to selected employees">
                <div class="selected-full-week-title">Drop here for full schedule</div>
                <div class="selected-full-week-subtitle">
                  Whole week for selected employees
                </div>
              </div>

              <!-- Per-day drop targets -->
              <div class="selected-dropzone-days">
                <button *ngFor="let d of weekDays; let i = index" type="button" class="selected-day-target"
                  [class.hover]="hoverSelectedEmployeesDayIndex === i"
                  [class.valid-drop]="isTemplateDragging && isTemplateDayDroppable(d.ymd)"
                  [class.invalid-drop]="isTemplateDragging && !isTemplateDayDroppable(d.ymd)"
                  (click)="openManualBulkCreateForSelectedDay(d.ymd)"
                  (dragenter)="onSelectedEmployeesDayDragEnter($event, i)"
                  (dragover)="onSelectedEmployeesDayDragOver($event, i)"
                  (dragleave)="onSelectedEmployeesDayDragLeave($event, i)"
                  (drop)="onDropToSelectedEmployeesDay($event, d.ymd)"
                  [title]="'Drop template for selected employees on ' + d.label">
                  <span class="selected-day-name">{{ d.label }}</span>
                  <span class="selected-day-date">{{ d.date | date: 'MMM d' }}</span>

                  <span class="selected-day-status" *ngIf="isTemplateDragging">
                    {{ isTemplateDayDroppable(d.ymd) ? 'Available' : 'No schedule' }}
                  </span>
                </button>
              </div>

              <div class="selected-dropzone-actions">
                <button type="button" class="nav-btn subtle" (click)="openManualBulkCreateForSelectedWeek()">
                  Create for selected week
                </button>
              </div>
            </div>

            <div class="sidebar-loading" *ngIf="isLoadingScheduleGroups">
              <div class="spinner small"></div>
              <span>Loading templates…</span>
            </div>

            <div class="template-card" *ngFor="let g of scheduleGroups; trackBy: trackByScheduleGroupId"
              draggable="true" (dragstart)="onTemplateDragStart($event, g.id)" (click)="toggleTemplateExpanded(g.id)"
              [class.expanded]="isTemplateExpanded(g.id)" [attr.aria-expanded]="isTemplateExpanded(g.id)">
              <div class="template-row">
                <div class="template-name">{{ g.name }}</div>

                <div class="template-meta">
                  <ng-container *ngIf="isTemplateLoading(g.id); else templateMetaText">
                    <span class="template-spinner" aria-label="Loading template details"></span>
                  </ng-container>
                  <ng-template #templateMetaText>{{ g.dayCount }} days</ng-template>
                </div>
              </div>

              <div class="template-actions" *ngIf="selectedEmployeeIds.size > 0">
                <button type="button" class="template-apply-selected"
                  (click)="$event.stopPropagation(); applyTemplateToSelectedEmployeesWeek(g.id)">
                  Apply to selected
                </button>
              </div>

              <div class="template-preview" *ngIf="isTemplateExpanded(g.id)">
                <div class="preview-line" *ngFor="let r of getTemplatePreview(g.id)">
                  <span class="preview-day">{{ r.dayLabel }}</span>
                  <span class="preview-time" [class.overnight]="r.isOvernight">
                    {{ r.timeRange }}
                  </span>
                </div>
              </div>
            </div>

            <div class="empty-state" *ngIf="!isLoadingScheduleGroups && !scheduleGroups.length">
              No templates available.
            </div>
          </div>
        </div>
      </aside>
    </div>
  </div>